import { Button, Form, Input, Select, Spin, Tag } from "antd";
import axios from "axios";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { AiOutlineEye } from "react-icons/ai";
// import { BiUserX } from "react-icons/bi";
// import { FiUserCheck } from "react-icons/fi";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import appConfig from "@/config/appConfig";
import { DataTable } from "@/components";
import { userRole } from "@/constant";
import { getFormatedUserType } from "@/utils/userTypeFomater";
import { flare } from "@flareapp/js";

const initState = {
  siteLocation: "",
  siteUser: [],
  dashboardId: "",
  dashboardType: "",
  selectedBusiness: "",
};

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};
const AssignDashboard = () => {
  const [form] = Form.useForm();

  const [businessesList, setBusinessesList] = useState([]);
  const { userDetails } = useSelector((state) => state.user);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [locations, setLocations] = useState([]);
  const [role, setRole] = useState("");
  const [dashboardList, setDashboardList] = useState([]);
  const [searchText, setSearchText] = useState("");
  // const [limit, setLimit] = useState(10);
  // const [page, setPage] = useState(1);
  // const [total, setTotal] = useState(0);
  // const [data, setData] = useState([]);
  // const [assign, setAssign] = useState([]);

  const [assignList, setAssignList] = useState([]);
  const [assignListTotal, setAssignListTotal] = useState(0);
  const [assignLimit, setAssignLimit] = useState(10);
  const [assignPage, setAssignPage] = useState(1);

  const [formData, setFormData] = useState(initState);
  const { selectedBusiness } = formData;

  // get location
  const getLocation = async (business) => {
    const response = await axios.get(`/site-location/my-site`, {
      withCredentials: true,
      params: {
        business,
        limit: 100,
      },
    });
    setLocations(response?.data);
  };

  // get site user
  const getUsers = async () => {
    // setIsLoading(true);
    try {
      if (formData.siteLocation) {
        const { results } = await api.get(endpoint.all_users + "/include-me", {
          params: {
            sortBy: "createdAt",
            orderBy: "DESC",
            role,
            site: formData.siteLocation,
            limit: 100000,
            page: 1,
            includeRequestSender: true,
          },
        });
        setUsers(results);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }

    // setIsLoading(false);
  };

  // get dashboard list
  const getDashboardList = async () => {
    // setIsLoading(true);
    const response = await api.get(endpoint.get_dashboard_list, {
      params: {
        // deviceId: device,
        business: selectedBusiness,
        limit: 1000,
        page: 1,
        type: formData.type,
      },
    });
    setDashboardList(response?.data || []);
    // setIsLoading(false);
  };

  useEffect(() => {
    document.title = `${appConfig.name} - Assign Dashboard `;
  }, []);

  // getAllAssignList
  const getAllAssignList = async () => {
    try {
      setIsLoading(true);
      const { results, count } = await api.get(endpoint.get_assign, {
        params: {
          limit: assignLimit,
          page: assignPage,
          // dashboardType: formData.dashboardType,
          sortBy: "createdAt",
          orderBy: "DESC",
          searchText,
        },
      });
      setAssignList(results);
      setAssignListTotal(count);
      setIsLoading(false);
    } catch (error) {
      flare.report(error);
      Swal.fire({
        title: "Ooops",
        text: error.message,
        icon: "danger",
        showCancelButton: false,
        // confirmButtonColor: "#3085d6",
        // cancelButtonColor: "#d33",
        // confirmButtonText: "Confirm",
      });
    }
  };

  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint.business);
      setBusinessesList(data?.data);
      if (Array.isArray(data?.data) && data.data.length === 1) {
        setFormData({ ...formData, selectedBusiness: data.data[0]._id });
        if (data?.data?.length === 1) {
          form.setFieldsValue({ selectedBusiness: data?.data[0]._id });
          getLocation(data?.data[0]._id);
        }
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  useEffect(() => {
    if (selectedBusiness) {
      getLocation(selectedBusiness);
      getDashboardList();
    }
  }, [selectedBusiness, formData.type]);

  useEffect(() => {
    getAllAssignList();
    getBusiness();
  }, [assignLimit, assignPage, searchText]);

  useEffect(() => {
    getUsers();
  }, [role, formData.siteLocation]);

  const handleRemoveAssign = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`/dashboard/assign/${id}`, {
          withCredentials: true,
        });
        getAllAssignList();
        Swal.fire({
          title: "Deleted!",
          text: "User Unassigned to Dashboard Successfully.",
          icon: "success",
          timer: 1500,
        });
      }
    });
  };

  const handleSubmit = async () => {
    // e.preventDefault();
    const body = {
      site: formData.siteLocation,
      user: formData.siteUser,
      dashboard: formData.dashboardId,
      business: formData.selectedBusiness,
      dashboardType: Number(formData.dashboardType),
    };

    try {
      await axios.post(endpoint.assign_dashboard, body, {
        withCredentials: true,
      });
      Swal.fire({
        title: "",
        text: "User assigned successfully.",
        icon: "success",
        timer: 1500,
      });
      setFormData(initState);
      getAllAssignList();
    } catch (error) {
      flare.report(error);
      if (error?.response) {
        Swal.fire({
          title: "Ooops",
          text: "User already assigned to the dashboard.",
          icon: "danger",
          timer: 1500,
        });
      }
    }
    // getAssign()
  };

  // const makeDefaultHandler = async (userId, dashboardId, isActive) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: !isActive
  //       ? "This will remove this dashboard as default dashboard."
  //       : "Make this dashboard as default dashboard.",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Confirm",
  //     confirmButtonColor: "#198754",
  //   })
  //     .then(async (result) => {
  //       if (result.isConfirmed) {
  //         const body = { userId, dashboardId, isActive };
  //         const { success } = await api.put(endpoint.active_dashboard, body);
  //         if (success) {
  //           // getAssign()
  //           getAllAssignList();
  //           Swal.fire({
  //             title: "Success!",
  //             text: !isActive
  //               ? "The default dashboard has been unassigned from this user."
  //               : "Default dashboard set successfully.",
  //             icon: "success",
  //             timer: 1500,
  //           });
  //         } else {
  //           Swal.fire({
  //             title: "Deleted!",
  //             text: "User has already default dashboard.",
  //             icon: "error",
  //             timer: 1500,
  //           });
  //         }
  //       }
  //     })
  //     .catch(() =>
  //       Swal.fire({
  //         title: "",
  //         text: "User has already default dashboard.",
  //         icon: "error",
  //         timer: 1500,
  //       }),
  //     );
  // };

  const LimitedTags = ({ list, limit = 3 }) => (
    <div>
      {Array.isArray(list)
        ? list.map((item, idx) =>
            idx < limit ? (
              <Tag key={idx} className="d-block my-1">
                {" "}
                {item.name}{" "}
              </Tag>
            ) : (
              ""
            ),
          )
        : ""}
      {list?.length > limit ? <Tag className="d-inline-block my-1"> + {list?.length - limit} ... </Tag> : ""}
    </div>
  );

  LimitedTags.propTypes = {
    list: PropTypes.array,
    limit: PropTypes.number,
  };

  const columnsList = [
    {
      title: "No.",
      render: (row, _, index) => index + 1,
      width: "60px",
    },
    {
      title: "Dashboard Name",
      render: (row) => row.dashboard?.name,
    },
    {
      title: "User Name",
      render: (row) => row.user?.name,
    },

    {
      title: "Business",
      render: (row) => <LimitedTags list={row?.user?.business} />,
      // grow: 2,
    },
    {
      title: "User Type",
      render: (row) => getFormatedUserType(row.user?.role),
      align: "center",
    },
    {
      title: "Date Assign",
      render: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
      align: "center",
    },
    {
      title: "Action",
      width: "220px",
      align: "center",
      render: (row) => (
        <div>
          <Link to={`/users/details/${row.user?._id}`}>
            <button className="me-2 btn btn-az-primary">
              <AiOutlineEye className="text-white" />
            </button>
          </Link>
          {/* EditDashboard */}
          {/* {row?.isActive ? (
            <button
              title="Default Selected"
              className="me-2 btn btn-success"
              onClick={() => makeDefaultHandler(row?.user?._id, row?.dashboard?._id, !row?.isActive)}
            >
              <FiUserCheck />
            </button>
          ) : (
            <button
              title="Make Default"
              onClick={() => makeDefaultHandler(row?.user?._id, row?.dashboard?._id, !row?.isActive)}
              className="btn btn-warning me-2"
            >
              <BiUserX className="text-white" />
            </button>
          )} */}
          <button className="me-2 btn btn-danger" onClick={() => handleRemoveAssign(row._id)}>
            <MdDeleteOutline className="text-white" />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="px-md-3 mt-3">
      <div className="border p-3">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <label className="az-content-label">Manage Dashboard</label>
            <span className="d-block py-2">Assign Dashboard</span>
          </div>
        </div>
        <hr className="mt-0 mb-5" />
        <h6 className="fw-bold mt-4">Assign Existing System User Accounts</h6>

        <Form layout="vertical" name="users" onFinish={handleSubmit} onFinishFailed={onFinishFailed} form={form} initialValues={{}}>
          <Row>
            <Col md={4}>
              <Form.Item label="Business" name="selectedBusiness" rules={[{ required: true, message: "Please select a business!" }]}>
                <Select
                  showSearch
                  className="text-secondary w-100"
                  onChange={(selectedBusiness) => setFormData({ ...formData, selectedBusiness })}
                  value={formData.selectedBusiness || undefined}
                  placeholder="Select Business"
                  disabled={businessesList?.length === 1}
                  options={
                    businessesList?.map((item) => ({
                      label: `${item.name} (${item.id})`,
                      value: item._id,
                    })) || []
                  }
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                />
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item label="Locations" name="siteLocation" rules={[{ required: true, message: "Please select a location!" }]}>
                <Select
                  className="text-secondary"
                  onChange={(value) => setFormData({ ...formData, siteLocation: value })}
                  value={formData.siteLocation}
                  placeholder="Select Site Location"
                  showSearch
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  options={
                    locations?.map((item) => ({
                      label: item.name,
                      value: item._id,
                    })) || []
                  }
                />
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item label="User Role" name="userType">
                <Select
                  className="text-secondary"
                  onChange={(value) => setRole(value)}
                  showSearch
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  value={role}
                  placeholder="All Roles"
                >
                  {Object.keys(userRole).map((role, idx) =>
                    role === userRole.superAdmin || Object.keys(userRole).indexOf(userDetails?.role) > idx ? null : (
                      <Select.Option key={role} value={role}>
                        {getFormatedUserType(role)}
                      </Select.Option>
                    ),
                  )}
                </Select>
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item label="Site User" name="siteUser" rules={[{ required: true, message: "Please select users!" }]}>
                <Select
                  showSearch
                  className="text-secondary w-100"
                  mode="multiple"
                  onChange={(siteUser) => setFormData({ ...formData, siteUser })}
                  value={formData.siteUser || []}
                  placeholder="Select User"
                  filterOption={(input, option) => (option?.label || "").toLowerCase().includes(input.toLowerCase())}
                  options={users.map((item) => ({ label: item.name, value: item._id }))}
                />
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item label="Dashboard Type" name="type" rules={[{ required: true, message: "Please select a dashboard type!" }]}>
                <Select
                  className="text-secondary"
                  value={formData.type || undefined}
                  showSearch={{
                    filterOption: (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase()),
                  }}
                  onChange={(value) => {
                    setFormData({ ...formData, type: value });
                  }}
                  placeholder="Select Dashboard"
                  options={[
                    { label: "Tile", value: "tile" },
                    { label: "Live", value: "live" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col md={4}>
              <Form.Item label="Dashboard" name="dashboardId" rules={[{ required: true, message: "Please select a dashboard!" }]}>
                <Select
                  className="text-secondary"
                  value={formData.dashboardType ? `${formData.dashboardType}:${formData.dashboardId}` : ""}
                  showSearch
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  onChange={(value) => {
                    const [dashboardType, _id] = value.split(":");
                    setFormData({ ...formData, dashboardType, dashboardId: _id });
                  }}
                  placeholder="Select Dashboard"
                  options={dashboardList?.map((item) => ({
                    label: item.name,
                    value: `${item.dashboardType}:${item._id}`,
                    searchLabel: `${item.type || "Tile"} - ${item.name}`,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={12} className="d-flex justify-content-end">
              <Button type="primary" htmlType="submit" className="px-4">
                Assign
              </Button>
            </Col>
          </Row>
        </Form>

        {/* <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={4}>
              <Form.Group className="my-2">
                <Form.Label>Business</Form.Label>
                <Select
                  showSearch={true}
                  filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                  required
                  className="text-secondary w-100"
                  onChange={(selectedBusiness) => setFormData({ ...formData, selectedBusiness })}
                  value={formData.selectedBusiness || []}
                  placeholder="Select Business"
                  disabled={businessesList?.length === 1}
                  options={
                    businessesList &&
                    businessesList?.map((item, index) => ({ label: `${item.name} (${item.id})`, value: item._id }))
                  }
                />
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="my-2">
                <Form.Label>Locations</Form.Label>
                <Form.Select
                  required
                  className="text-secondary"
                  onChange={handleChange}
                  value={formData.siteLocation}
                  name="siteLocation"
                >
                  <option value="">Select Site Location</option>
                  {locations &&
                    locations.map((item, index) => (
                      <option key={index} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="my-2">
                <Form.Label>User Role</Form.Label>
                <Form.Select
                  className="text-secondary"
                  onChange={(e) => setRole(e.target.value)}
                  value={role}
                  name="userType"
                >
                  <option value="" disabled>
                    All Roles
                  </option>
                  {Object.keys(userRole).map((role, idx) =>
                    role === userRole.superAdmin || Object.keys(userRole).indexOf(userDetails?.role) > idx ? (
                      ""
                    ) : (
                      <option key={role} value={role}>
                        {getFormatedUserType(role)}
                      </option>
                    )
                  )}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="my-2">
                <Form.Label>Site User</Form.Label>
                <Select
                  showSearch={true}
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.children ? option?.children.toLowerCase() : "").includes(input?.toLowerCase())
                  }
                  required
                  className="text-secondary"
                  onChange={(siteUser) => setFormData({ ...formData, siteUser })}
                  value={formData.siteUser || []}
                  name="siteUser"
                  placeholder="Select User"
                  mode="multiple"
                >
                  {users.length > 0 &&
                    users.map((item, index) => (
                      <option key={index} value={item._id}>
                        {item.name}
                      </option>
                    ))}
                </Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="my-2">
                <Form.Label>Dashboard</Form.Label>
                <Form.Select
                  required
                  value={formData.dashboardType ? `${formData.dashboardType}:${formData.dashboardId}` : ""}
                  className="text-secondary"
                  onChange={(e) => {
                    const [dashboardType, _id] = e.target.value.split(":");
                    setFormData({
                      ...formData,
                      dashboardType: dashboardType,
                      dashboardId: _id,
                    });
                  }}
                  name="dashboardId"
                >
                  <option value="">Select dashboard</option>
                  {dashboardList &&
                    dashboardList?.map((item, index) => (
                      <option key={index} value={`${item.dashboardType}:${item._id}`}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col xs={12} className="d-flex justify-content-end">
              <div className="marginTop">
                <Button htmlType="submit" type="primary" className="px-4">
                  Assign
                </Button>
              </div>
            </Col>
          </Row>
        </Form> */}
        <hr />
        <div className="mt-4">
          <div>
            <h6 className="fw-bold"> Assigned List </h6>
            <div className="row">
              <div className="col-md-10"></div>
              <div className="col-md-2">
                <Input
                  type="search"
                  size="large"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setAssignPage(1);
                  }}
                  placeholder="Search"
                  aria-label="Search"
                />
              </div>
            </div>
            <Spin spinning={isLoading}>
              <DataTable
                columns={columnsList}
                dataSource={assignList}
                pagination={{
                  pageSize: assignLimit,
                  current: assignPage,
                  total: assignListTotal,
                  showSizeChanger: true,
                  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
                  pageSizeOptions: [10, 20, 50],
                  responsive: true,
                }}
                onChange={({ pageSize, current }) => {
                  setAssignLimit(pageSize);
                  setAssignPage(current);
                }}
              />
            </Spin>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignDashboard;
